import { AdminApi } from './api/api'
import { Configuration } from './api/configuration'
import { axiosInstance } from './axios'

export default class AuthenticatedApi extends AdminApi {
  constructor(token: string) {
    const configuration = new Configuration({
      accessToken: token,
    })
    const basePath = process.env.REACT_APP_API_BASE_URL
    super(configuration, basePath, axiosInstance)
  }
}
